import { useMediaQuery } from '@mui/material'

export const useIsMobile = () => useMediaQuery('(max-width:600px)')
export const useIsTablet = () => useMediaQuery('(max-width:960px)')
export const useIsScannerScreenMidSize = () =>
  useMediaQuery('(max-width:1330px)')
